import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <p className="font-heading text-7xl md:text-9xl font-bold text-primary-500">404</p>
          <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mt-4">
            页面未找到
          </h1>
          <p className="text-foreground-500 mt-2 text-sm">你访问的页面可能已被移除或地址有误</p>
          <Link
            to="/"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-primary-500 text-white font-medium text-sm mt-6 whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer no-underline"
          >
            <i className="ri-arrow-left-line mr-1.5"></i>
            {t('backToHome')}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}